<div (clickOutside)="closeWhenClickedOutside($event)">
    <mpro-text-input class="datepicker-text-input" [readonly]="true" (clear)="clearDate() " [formControl]="dateInput" [title]="title" [subtitle]="subtitle"
        placeholder="DD/MM/YYYY" (focus)="isOpen = true"></mpro-text-input>

    <div class="datepicker">
        <ngb-datepicker *ngIf="isOpen" class="mpro-box" [formControl]="date" [dayTemplate]="customDay" [minDate]="minDate">
        </ngb-datepicker>
        <ng-template #customDay let-date let-today="today" let-currentMonth="currentMonth" let-selected="selected">
            <span class="custom-day" [class.selected]="selected" [class.today]="today"
                [class.gray-out]="date.month !== currentMonth">
                {{ date.day }}
            </span>
        </ng-template>
    </div>
</div>